import { OG_PATH, getCanonicalUrl } from "@/content";
import {PageSeo} from "@modes0/ui-components-seo";
import {seoSiteProfile} from "@/content/seo";
import {
    projectDisplayFilters,
    projectDisplayItems,
    projectDisplayTotalCount,
} from "@/content/projects/project-display";
import type { MetaTagsProps } from "@/types";
import { ProjectDisplay } from "@modes0/ui-components/client";
import Link from "next/link";

const projectsMetaTags: MetaTagsProps = {
    title: "Projects | Grow Leads",
    description:
        "Explore Grow Leads website, SEO, Google setup, automation and media projects for Australian service businesses.",
    keywords: "Grow Leads projects, website design portfolio, SEO projects Sydney, digital marketing case studies",
    url: getCanonicalUrl("/projects"),
    ogImage: `${OG_PATH}img2.jpg`,
    type: "website",
};

export default function ProjectsPage() {
    return (
        <>
            <PageSeo meta={projectsMetaTags} siteProfile={seoSiteProfile} />
            <ProjectDisplay
                Link={Link}
                items={projectDisplayItems}
                layout="stack"
                className="projects-page-display"
                eyebrow="Our Work"
                titleComponent="h1"
                title={
                    <>
                        Projects That <span className="project-display-title-highlight">Drive Growth.</span>
                    </>
                }
                description="Browse the full Grow Leads project list across websites, SEO, Google setup, automation, retail, trades and media."
                filters={projectDisplayFilters}
                allFilterLabel="All Projects"
                allFilterCount={projectDisplayTotalCount}
                allFilterIconToken="grid"
                filterAriaLabel="Project categories"
                ctaLabel="View Project"
                accentColor="#2faa2e"
                backgroundColor="#ffffff"
                surfaceColor="#ffffff"
                // maxWidth={1440}
                tileWidth={212}
                minTileWidth={212}
                imageHeight={190}
                ariaLabel="Grow Leads project portfolio"
                style={{ padding: "clamp(36px, 5vw, 52px) 16px clamp(44px, 6vw, 56px)" }}
            />
        </>
    );
}
